export const SET_BRANDING_ARRAY = 'SetBrandingArray';
export const SET_COMPANY = 'SetCompany';
export const SET_BRAND = 'SetBrand';
export const SET_MODE = 'SetMode';
export const SET_BRANDING_VARS = 'SetBrandingVars';
